import { Box, Flex, Skeleton, rem } from "@mantine/core";

/**
 * Skeleton no formato do dashboard (embed do Metabase): uma linha de tiles de
 * indicadores + blocos de gráficos. Usado tanto enquanto a URL do embed é
 * buscada quanto como overlay enquanto o iframe ainda não pintou — o embed
 * demora e antes ficava só um branco vazio, sem feedback nenhum.
 */
export function DashboardPageSkeleton() {
  return (
    <Flex
      data-testid="dashboard-skeleton"
      direction="column"
      gap={rem(16)}
      p={rem(24)}
      style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      {/* Linha de tiles de indicadores (KPIs) */}
      <Flex
        gap={rem(16)}
        wrap="wrap">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            height={rem(96)}
            radius="md"
            style={{ flex: "1 1 160px" }}
          />
        ))}
      </Flex>

      {/* Bloco de gráfico principal */}
      <Skeleton
        height={rem(240)}
        radius="md"
        style={{ width: "100%" }}
      />

      {/* Dois gráficos lado a lado */}
      <Flex
        gap={rem(16)}
        wrap="wrap"
        style={{ flex: 1, minHeight: rem(160) }}>
        <Box style={{ flex: "1 1 280px", minHeight: rem(160) }}>
          <Skeleton
            height="100%"
            radius="md"
          />
        </Box>
        <Box style={{ flex: "1 1 280px", minHeight: rem(160) }}>
          <Skeleton
            height="100%"
            radius="md"
          />
        </Box>
      </Flex>
    </Flex>
  );
}
